/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 22.0002C15.3137 22.0002 18 19.7617 18 17.0002C18 14.2388 15.3137 12.0002 12 12.0002C8.68629 12.0002 6 9.76167 6 7.00024C6 4.23882 8.68629 2.00024 12 2.00024M11.5 7.00024C11.5 7.27639 11.2761 7.50024 11 7.50024C10.7239 7.50024 10.5 7.27639 10.5 7.00024M11.5 7.00024C11.5 6.7241 11.2761 6.50024 11 6.50024C10.7239 6.50024 10.5 6.7241 10.5 7.00024M11.5 7.00024H10.5M13.5 17.0002C13.5 17.2764 13.2761 17.5002 13 17.5002C12.7239 17.5002 12.5 17.2764 12.5 17.0002M13.5 17.0002C13.5 16.7241 13.2761 16.5002 13 16.5002C12.7239 16.5002 12.5 16.7241 12.5 17.0002M13.5 17.0002H12.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 12.0002C22 17.5231 17.5228 22.0002 12 22.0002C6.47716 22.0002 2 17.5231 2 12.0002C2 6.4774 6.47716 2.00024 12 2.00024C17.5228 2.00024 22 6.4774 22 12.0002Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 12C2 17.5228 6.47716 22 12 22C15.3137 22 18 19.7614 18 17C18 14.2386 15.3137 12 12 12C8.68629 12 6 9.76142 6 7C6 4.23858 8.68629 2 12 2C6.47716 2 2 6.47715 2 12Z"
				fill="currentColor"
			/>
			<path
				d="M12 22.0002C17.5228 22.0002 22 17.5231 22 12.0002C22 6.4774 17.5228 2.00024 12 2.00024M12 22.0002C6.47716 22.0002 2 17.5231 2 12.0002C2 6.4774 6.47716 2.00024 12 2.00024M12 22.0002C15.3137 22.0002 18 19.7617 18 17.0002C18 14.2388 15.3137 12.0002 12 12.0002C8.68629 12.0002 6 9.76167 6 7.00024C6 4.23882 8.68629 2.00024 12 2.00024M11.5 7.00024C11.5 7.27639 11.2761 7.50024 11 7.50024C10.7239 7.50024 10.5 7.27639 10.5 7.00024M11.5 7.00024C11.5 6.7241 11.2761 6.50024 11 6.50024C10.7239 6.50024 10.5 6.7241 10.5 7.00024M11.5 7.00024H10.5M13.5 17.0002C13.5 17.2764 13.2761 17.5002 13 17.5002C12.7239 17.5002 12.5 17.2764 12.5 17.0002M13.5 17.0002C13.5 16.7241 13.2761 16.5002 13 16.5002C12.7239 16.5002 12.5 16.7241 12.5 17.0002M13.5 17.0002H12.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.4928 4.30556C4.33452 4.84394 4.24994 5.41118 4.24994 6C4.24994 9.83223 7.83236 12.75 11.9999 12.75C15.5643 12.75 18.2499 15.2048 18.2499 18C18.2499 19.518 17.4579 20.9356 16.1631 21.9142C14.8827 22.4525 13.4761 22.75 12 22.75C6.06294 22.75 1.25001 17.9371 1.25001 12C1.25001 8.98385 2.49215 6.25782 4.4928 4.30556ZM7.83661 2.08594C6.54195 3.06449 5.74994 4.48205 5.74994 6C5.74994 8.7952 8.43553 11.25 11.9999 11.25C16.1675 11.25 19.7499 14.1678 19.7499 18C19.7499 18.5889 19.6653 19.1562 19.507 19.6946C21.5078 17.7423 22.75 15.0162 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C10.5238 1.25 9.11711 1.54755 7.83661 2.08594ZM10.9999 4.75025C10.3096 4.75025 9.74994 5.30989 9.74994 6.00025C9.74994 6.6906 10.3096 7.25025 10.9999 7.25025C11.6903 7.25025 12.2499 6.6906 12.2499 6.00025C12.2499 5.30989 11.6903 4.75025 10.9999 4.75025ZM12.9999 16.7502C12.3096 16.7502 11.7499 17.3099 11.7499 18.0002C11.7499 18.6906 12.3096 19.2502 12.9999 19.2502C13.6903 19.2502 14.2499 18.6906 14.2499 18.0002C14.2499 17.3099 13.6903 16.7502 12.9999 16.7502Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 22.0002C17.5228 22.0002 22 17.5231 22 12.0002C22 6.47739 17.5228 2.00024 12 2.00024M12 22.0002C6.47716 22.0002 2.00001 17.5231 2.00001 12.0002C2.00001 6.47739 6.47716 2.00024 12 2.00024M12 22.0002C15.3137 22.0002 18 19.7617 18 17.0002C18 14.8232 16.3304 12.9711 14 12.2847M12 2.00024C8.6863 2.00024 6.00001 4.23882 6.00001 7.00024C6.00001 9.33004 7.91216 11.2877 10.5 11.8427M11.5 7.00024C11.5 7.27638 11.2761 7.50024 11 7.50024C10.7239 7.50024 10.5 7.27638 10.5 7.00024M11.5 7.00024C11.5 6.7241 11.2761 6.50024 11 6.50024C10.7239 6.50024 10.5 6.7241 10.5 7.00024M11.5 7.00024H10.5M13.5 17.0002C13.5 17.2764 13.2761 17.5002 13 17.5002C12.7239 17.5002 12.5 17.2764 12.5 17.0002M13.5 17.0002C13.5 16.7241 13.2761 16.5002 13 16.5002C12.7239 16.5002 12.5 16.7241 12.5 17.0002M13.5 17.0002H12.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 22.0002C17.5229 22.0002 22 17.5231 22 12.0002C22 6.47739 17.5229 2.00024 12 2.00024M12 22.0002C6.47717 22.0002 2.00002 17.5231 2.00002 12.0002C2.00002 6.47739 6.47717 2.00024 12 2.00024M12 22.0002C15.3137 22.0002 18 19.7617 18 17.0002C18 14.2388 15.3137 12.0002 12 12.0002C8.68631 12.0002 6.00002 9.76167 6.00002 7.00024C6.00002 4.23882 8.68631 2.00024 12 2.00024M11.5 7.00024C11.5 7.27638 11.2762 7.50024 11 7.50024C10.7239 7.50024 10.5 7.27638 10.5 7.00024M11.5 7.00024C11.5 6.7241 11.2762 6.50024 11 6.50024C10.7239 6.50024 10.5 6.7241 10.5 7.00024M11.5 7.00024H10.5M13.5 17.0002C13.5 17.2764 13.2762 17.5002 13 17.5002C12.7239 17.5002 12.5 17.2764 12.5 17.0002M13.5 17.0002C13.5 16.7241 13.2762 16.5002 13 16.5002C12.7239 16.5002 12.5 16.7241 12.5 17.0002M13.5 17.0002H12.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M1.25013 12C1.25013 17.9371 6.06307 22.75 12.0001 22.75C14.3114 22.75 16.4524 22.0206 18.2053 20.7794C18.7129 19.9484 19 19.003 19 18C19 14.6863 15.866 12 12 12C8.13401 12 5.00001 9.31371 5.00001 6.00001C5.00001 4.99717 5.28704 4.05179 5.79453 3.22095C3.04494 5.16807 1.25013 8.37443 1.25013 12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 1.25C17.9372 1.25 22.7501 6.06294 22.7501 12C22.7501 15.6258 20.9551 18.8323 18.2053 20.7794C18.7129 19.9484 19 19.003 19 18C19 14.6863 15.866 12 12 12C8.13401 12 5.00001 9.31371 5.00001 6C5.00001 4.99716 5.28704 4.05178 5.79453 3.22094C7.54754 1.97954 9.68864 1.25 12.0001 1.25ZM11 7C11.5523 7 12 6.55228 12 6C12 5.44771 11.5523 5 11 5C10.4477 5 10 5.44771 10 6C10 6.55228 10.4477 7 11 7Z"
				fill="currentColor"
			/>
			<path
				d="M13 19C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
